import LoaderSpinnerSvg from "@assets/images/btn_loader_spinner.svg";

type Props = {
  loading?: boolean;
};

const ButtonSpinner = ({ loading }: Props) => {
  if (!loading) {
    return null;
  }
  return <img src={LoaderSpinnerSvg} alt="loading" width={24} height={24} className="absolute -left-9 mt-0.5 animate-spin" />;
};

export default ButtonSpinner;
